import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
} from '@angular/core';
import { BaseComponent } from '@macs-frontend/core';
import { makeSelectable } from '@macs-frontend/decorators';
import { InvoiceStatuses, SPO } from '@macs-frontend/features/shared';
import { BaseSPO, SPOStatuses } from '@macs-frontend/features/shared/models/spo';
import { Store } from '@ngrx/store';

@Component({
  selector: 'md-spo-status-tooltip',
  templateUrl: 'spo-status-tooltip.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpoStatusTooltipComponent extends BaseComponent {
  @Input()
  spo?: BaseSPO;
  invoiceStatuses = InvoiceStatuses;
  validStatuses = [SPOStatuses.REJECTED, SPOStatuses.IN_REVIEW];
  statusTooltipCation: Record<string, string> = {
    [SPOStatuses.REJECTED]: 'Rejected',
    [SPOStatuses.IN_REVIEW]: 'In review',
  };
  constructor(readonly cdr: ChangeDetectorRef, readonly store$: Store) {
    super();
    makeSelectable(this, { cdr, store$ });
  }

  protected readonly InvoiceStatuses = InvoiceStatuses;

  isError() {
    const errorStatuses: Record<string, boolean> = {
      [SPOStatuses.REJECTED]: true,
    };

    return errorStatuses[this.spo?.status || ''];
  }
}
